'use client';

import { TranslationType, useTranslation as useTranslation_ } from 'intl-lib';
import { useMemo } from 'react';
import { useLatest } from 'react-use';

export function useTranslation<U>(
  selector: (translation: TranslationType) => U
): U;
export function useTranslation(): TranslationType;
export function useTranslation(selector?: (...args: any) => any) {
  const translation = useTranslation_();
  const selectorRef = useLatest(selector);
  return useMemo(() => {
    const selector = selectorRef.current;
    return selector ? selector(translation) : translation;
  }, [translation]);
}
